import { render } from "./TaxableIncome.vue?vue&type=template&id=6f7eb187&scoped=true"
import script from "./TaxableIncome.vue?vue&type=script&lang=js"
export * from "./TaxableIncome.vue?vue&type=script&lang=js"

import "./TaxableIncome.vue?vue&type=style&index=0&id=6f7eb187&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7eb187"]])

export default __exports__